export default {
    home: '首页',
    _home: '艺袋鼠',
    agentList: '代理列表',
    agentManagement: "代理管理",
    schoolManagement: '校区管理',
    schoolList: '校区列表',
    teacherList: '老师列表',
    studentList: '学生列表',
    classList: '班级列表',
    chapterPermission: '教师章节权限列表',
    appContent: 'APP内容管理',
    courseCategory: '课程类别管理',
    courseMassage: '课程信息管理',
    studentCourseCatalogue: '学生课程目录管理',
    teacherCourseCatalogue: '老师课程目录管理',
    rechargeList: '充值记录',
    bannerList: 'banner管理',
    videoManagement: '视频管理',
    everydayList: '每日跟我弹列表',
    askMeAbout: '名师在线列表',
    teacherVideo: '老师视频管理',
    studentVideo: '学生视频管理',
    studentMien: '学生风采管理',

    videoType: '视频类别管理',
    everydayStatistics: '每日会员统计',
    operationManagement: '运营管理',
    consultEnroll: '咨询报名管理',
    orderList: '学生会员订单管理',
    schoolOrder: '校区订单管理',
    memberPricing: '会员时长定价管理',
    chargesSatistics: '收费统计管理',

    mallManagement: '商城管理',
    goodsManagement: '商品管理',
    goodsTypeManagement: '商品分类管理',
    goodsOrder: '商品订单管理',

    systemManagement: '系统管理',
    adminList: '系统账号管理',
    roleList: '角色管理',
    editionManage: '版本管理',

    chapterManagement: '章节管理',
    components: '组件',
    chargeStatistics: '收费统计',
    commentManagement: '学生评论管理',

    count_to_page: '数字渐变',
    tables_page: '多功能表格',
    split_pane_page: '分割窗口',
    markdown_page: 'Markdown编辑器',
    editor_page: '富文本编辑器',
    icons_page: '自定义图标',
    img_cropper_page: '图片编辑器',
    update: '上传数据',
    join_page: 'QQ群',
    doc: '文档',
    update_table_page: '上传CSV文件',
    update_paste_page: '粘贴表格数据',
    multilevel: '多级菜单',
    directive_page: '指令',
    level_1: 'Level-1',
    level_2: 'Level-2',
    level_2_1: 'Level-2-1',
    level_2_3: 'Level-2-3',
    level_2_2: 'Level-2-2',
    level_2_2_1: 'Level-2-2-1',
    excel: 'Excel',
    'upload-excel': '上传excel',
    'export-excel': '导出excel',
    tools_methods_page: '工具函数',
    drag_list_page: '拖拽列表',
    i18n_page: '多语言',
    modalTitle: '模态框题目',
    content: '这是模态框内容',
    buttonText: '显示模态框',
    'i18n-tip': '注：仅此页做了多语言，其他页面没有在多语言包中添加语言内容',
    error_store_page: '错误收集',
    error_logger_page: '错误日志'

}